/**
 * @generated SignedSource<<eeaa08792d3d696b5f0b241744fdd9d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
export type ProductAppStatus = "active" | "inactive" | "%future added value";
export type ProductAppVisibility = "admin" | "all" | "membership" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AppSidebarItemFragment$data = {
  readonly badge: {
    readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
  };
  readonly customAppTitle: string | null;
  readonly forYouDashboard: {
    readonly id: string;
  } | null;
  readonly kind: ProductAppKind;
  readonly product: {
    readonly " $fragmentSpreads": FragmentRefs<"usePermissionsFragment">;
  } | null;
  readonly status: ProductAppStatus;
  readonly visibility: ProductAppVisibility;
  readonly " $fragmentSpreads": FragmentRefs<"RemoveAppButtonFragment" | "ToggleAppStatusButtonFragment">;
  readonly " $fragmentType": "AppSidebarItemFragment";
};
export type AppSidebarItemFragment$key = {
  readonly " $data"?: AppSidebarItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppSidebarItemFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppSidebarItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customAppTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Badge",
      "kind": "LinkedField",
      "name": "badge",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BadgeFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "usePermissionsFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dashboard",
      "kind": "LinkedField",
      "name": "forYouDashboard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RemoveAppButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToggleAppStatusButtonFragment"
    }
  ],
  "type": "ProductApp",
  "abstractKey": null
};

(node as any).hash = "2d6a581a75b779464fdc20962cfbb120";

export default node;
